import React, { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Card, Spinner } from "@/components/common";
import { wpApi, useWP } from "./wpApi";

export default function WPGuard({ children }) {
  const { user } = useAuth();
  const { t } = useWP();
  const isSuper = user?.role === "super_admin";
  const [state, setState] = useState(isSuper ? "loading" : "denied");

  useEffect(() => {
    if (!isSuper) return;
    wpApi.status().then(() => setState("ok")).catch(() => setState("off"));
  }, [isSuper]);

  if (state === "loading") return <Spinner />;
  if (state === "ok") return children;
  return (
    <Card className="p-8 max-w-xl" data-testid="wp-guard-message">
      <h1 className="text-xl font-bold text-white">{t("Website-Produktion")}</h1>
      <p className="mt-2 text-sm text-gray-400">
        {state === "denied" ? t("Dieser Bereich ist nur für Super Admins zugänglich.") : t("Dieses Modul ist in dieser Umgebung nicht aktiv.")}
      </p>
      {state === "off" && (
        <p className="mt-2 text-sm text-gray-400" data-testid="wp-guard-pc-hint">
          {t("Die Website-Produktion läuft nur lokal auf dem PC (lokale Datenbank, ausdrücklich aktiviert). Aufträge und Verbindungsstatus:")}{" "}
          <a href="/admin/pc-production" className="underline text-white">{t("PC-Produktion")}</a>
        </p>
      )}
    </Card>
  );
}
